import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonClassNames, InputRegexPattern, LocalStorageItems, ModalVariants } from '../../../../../../models/Common';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { FormInputText } from '../../../../../inputs/FormInputText';
import { useAppDispatch } from '../../../../../../hooks/redux';
import { userInfoApi } from '../../../../../../services/apiServices/user/userInfo';
import { modalSlice } from '../../../../../../store/reducers/ModalSlice';
import { useCustomSnackbar } from '../../../../../../hooks/useCustomEnqueueSnackbar';
import { getErrorMessage } from '../../../../../../utils';

export const AddNewEmail: FC = () => {
  const { t } = useTranslation();
  const methods = useForm<{ editEmail: string }>();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const { handleSubmit } = methods;
  const [addNewEmailApi, { isLoading }] = userInfoApi.useAddNewEmailMutation();
  const { openModal } = modalSlice.actions;
  const dispatch = useAppDispatch();

  const handleEditEmail = async ({ newEmail }: { newEmail: string }) => {
    try {
      await addNewEmailApi({ newEmail })
        .unwrap()
        .then(() => {
          dispatch(
            openModal({
              modalVariants: ModalVariants.Success,
              content: {
                title: `${t('input.newEmail')}!`,
                description: `${t('accountSettings.confirmationMessageHasBeenSentToMail')} - `,
                boldDescription: newEmail,
              },
            }),
          );
          localStorage.setItem(LocalStorageItems.Email, newEmail);
        });
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('accountSettings.addingEmail')}</article>
        <p className="modals__header__description">{t('accountSettings.confirmationEmailWillBeSentToEmail')}</p>
      </div>
      <form className="modals__form" onSubmit={handleSubmit(handleEditEmail)}>
        <FormProvider {...methods}>
          <FormInputText
            name="newEmail"
            className="primary"
            label={t('input.email')}
            isRequired
            minLength={4}
            maxLength={99}
            pattern={InputRegexPattern.Email}
          />
          <div className="modals__btn-group">
            <CustomMUIButton
              label={t('buttons.save')}
              type="submit"
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
              isLoading={isLoading}
            />
          </div>
        </FormProvider>
      </form>
    </div>
  );
};
